import React from 'react';
import './styles/us.css';

const Us: React.FC = () => {
  return (
    <section className="us-page">
      <div className="us-hero">
        <div className="us-hero-content">
          <span className="us-hero-eyebrow">Institución Técnica — Maicao, La Guajira</span>
          <h1 className="us-title">Quiénes somos</h1>
          <p className="us-subtitle">
            En CECAP, desde Maicao, La Guajira, creemos que aprender abre puertas. Diseñamos formación
            práctica, clara y acompañada para convertir el esfuerzo en oportunidades reales de empleo y
            emprendimiento.
          </p>
        </div>
        <div className="us-hero-glow" />
      </div>

      <div className="us-grid">
        <div className="us-card us-mission">
          <h2>
            <span className="us-icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 2l3 7h7l-5.5 4 2.5 7-7-4-7 4 2.5-7L2 9h7z"/>
              </svg>
            </span>
            Misión
          </h2>
          <p>
            Impulsar el desarrollo de Maicao y La Guajira formando habilidades útiles y medibles, con
            programas accesibles y orientados a resultados que conecten el aprendizaje con el trabajo y los
            negocios locales.
          </p>
        </div>

        <div className="us-card us-vision">
          <h2>
            <span className="us-icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 11a4 4 0 110-8 4 4 0 010 8z"/>
              </svg>
            </span>
            Visión
          </h2>
          <p>
            Ser el referente de formación aplicada en La Guajira, expandiendo nuestro impacto desde Maicao con
            programas innovadores, alianzas estratégicas y egresados que transformen su entorno.
          </p>
        </div>

        <div className="us-card us-values">
          <h2>
            <span className="us-icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.22 2.6C11.09 5.01 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </span>
            Valores
          </h2>
          <ul>
            <li><strong>Excelencia</strong>: altos estándares en contenido y servicio.</li>
            <li><strong>Integridad</strong>: transparencia y responsabilidad.</li>
            <li><strong>Cercanía</strong>: acompañamiento humano y personalizado.</li>
            <li><strong>Inclusión</strong>: oportunidades para diversos perfiles y ritmos.</li>
            <li><strong>Innovación</strong>: aprendizaje activo, actualizado y útil.</li>
            <li><strong>Resultados</strong>: habilidades que se notan en la práctica.</li>
            <li><strong>Compromiso regional</strong>: crecimiento para nuestra comunidad.</li>
          </ul>
        </div>

        <div className="us-card us-areas">
          <h2>
            <span className="us-icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
              </svg>
            </span>
            Áreas de especialidad
          </h2>
          <div className="us-tags">
            <span className="us-tag">Tecnología y ofimática</span>
            <span className="us-tag">Empleabilidad</span>
            <span className="us-tag">Emprendimiento y gestión</span>
            <span className="us-tag">Marketing digital</span>
            <span className="us-tag">Atención al cliente y ventas</span>
            <span className="us-tag">Finanzas básicas</span>
            <span className="us-tag">Idiomas con enfoque laboral</span>
            <span className="us-tag">Habilidades blandas</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Us;